import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AlignedCommitment } from '../aligned-commitments.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AlignedCommitment, unknown>[] = [
		buildColumn(util, 'Id', row => row.accProspectCommitmentId, { header: 'accProspectCommitmentId' }),
		buildColumn(util, 'Id', row => row.commitmentId, { header: 'commitmentId' }),
		buildColumn(util, 'Id', row => row.donorId, { header: 'donorId' }),
		buildColumn(util, 'Text', row => row.donorName, { header: 'Donor' }),
		buildColumn(util, 'Text', row => row.name, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.startTrimester, { header: 'Start Trimester', width: 100 }),
		buildColumn(util, 'Text', row => row.endTrimester, { header: 'End Trimester', width: 100, hidden: true }),
		buildColumn(util, 'Percent', row => row.actualProgress, { header: 'Actual Progress', width: 80, headerTooltip: 'Includes only Accepted Seats' }),
		buildColumn(util, 'Percent', row => row.potentialProgress, { header: 'Potential Progress', width: 80, headerTooltip: 'Includes Actual Progress, plus Considers' }),
		buildColumn(util, 'Text', row => row.matchDifficulty, { header: 'Difficulty', width: 100 }),
		buildColumn(util, 'Percent', row => row.urgency, { header: 'Urgency', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.impact, { header: 'Impact' }),
	];


	return columns;

}